import request from '@/middleware/request'

const getListGenAI = data => {
  return request({
    url: '/gen_ai/list',
    method: 'post',
    data
  })
}
const createGenAI = data => {
  return request({
    url: '/gen_ai',
    method: 'post',
    data
  })
}
const deleteGenAI = id => {
  return request({
    url: `/gen_ai/${id}`,
    method: 'delete'
  })
}
const updateGenAI = (id, data) => {
  return request({
    url: `/gen_ai/${id}`,
    method: 'patch',
    data
  })
}
const testGenAI = data => {
  return request({
    url: `/gen_ai/test_gen_ai`,
    method: 'post',
    data
  })
}
export default {
  getListGenAI,
  createGenAI,
  deleteGenAI,
  updateGenAI,
  testGenAI
}
